import { StatesModule, Transition } from '@uirouter/angular';
import { FiAuthStatesLoginAuthState } from '@fi-app/authenticate/states/login-auth';
import { FiAuthStatesLoginLoginHelpState } from '@fi-app/authenticate/states/login-help';
import { FiAuthStatesLoginHelpOtherState } from '@fi-app/authenticate/states/help-other';
import { FiAuthStatesLoginTokenState } from '@fi-app/authenticate/states/token';
import { FiAuthStatesLoginLicenceAgreementState } from '@fi-app/authenticate/states/licence-agreement';
import { FiAuthStatesLoginConfidentialAgreementState } from '@fi-app/authenticate/states/confidential-agreement';
import { FiAuthStatesLoginRequestAccessState } from '@fi-app/authenticate/states/reuest-access';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAuthenticateStates: StatesModule = {
    states: [
        {
            name: FiStateNames.Login._name,
            abstract: true,
            url: '/Login',
            component: FiAbstractStateComponent,
        },
        {
            name: FiStateNames.LoginV2._name, // todo obsolete, remove state in 6.04+
            url: '/LoginV2?{:magicLink}&{:autoLogin}',
            redirectTo: FiStateNames.Login.Auth,
        },
        FiAuthStatesLoginAuthState,
        FiAuthStatesLoginLoginHelpState,
        FiAuthStatesLoginHelpOtherState,
        FiAuthStatesLoginTokenState,
        FiAuthStatesLoginLicenceAgreementState,
        FiAuthStatesLoginConfidentialAgreementState,
        FiAuthStatesLoginRequestAccessState,
    ],
};
